import { Col, Row } from "react-bootstrap";
import { m } from "framer-motion";
import { fadeIn } from "../../Functions/GlobalAnimations";

const Leadership = () => {
  return (
    <m.div className="container  mt-[200px] ">
      <Col xl={8} lg={10} className="text-center mt-[200px] w-fit">
        <h3 className="font-serif text-[30px] mb-[2px]  font-medium text-[#146084] -tracking-[1px]">
          Leadership
        </h3>
        <m.div
          className="border-b border-1 w-[40%] border-[#146084]"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        />
      </Col>
      <Row className="items-center mb-[100px] mt-[50px] justify-center">
        <Col xs={10} lg={12} className="relative ">
          <Row className="flex justify-center mb-2">
            <Col xs={12} sm={12} lg={12}>
              <div className=" flex flex-col w-[100%] items-center">
                <img
                  className="w-[200px] h-[200px] rounded-full"
                  alt=""
                  src="/images/CM.webp"
                />
                <m.span
                  className="  font-bold text-center text-[20px] mt-[10px]  font-serif text-darkgray  block"
                  {...{ ...fadeIn, transition: { delay: 0.4 } }}
                >
                  Shri. V.D. Satheesan
                </m.span>
                <m.span
                  className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block"
                  {...{ ...fadeIn, transition: { delay: 0.4 } }}
                >
                  Hon. Chief Minister, Govt. of Kerala
                </m.span>
              </div>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col xs={12} sm={12} lg={6}>
              <div className="flex flex-col w-[100%] sm:w-[100%] items-center">
                <img
                  className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full"
                  alt=""
                  src="/images/Sidhiqu_Minister_Photo.webp"
                />
                <m.span
                  className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block"
                  {...{ ...fadeIn, transition: { delay: 0.4 } }}
                >
                  Shri. T. Siddique
                </m.span>
                <m.span
                  className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block"
                  {...{ ...fadeIn, transition: { delay: 0.4 } }}
                >
                  Hon. Minister for Agriculture, Govt. of Kerala
                  <br />
                </m.span>
              </div>
            </Col>
            <Col xs={12} sm={12} lg={6}>
              <div className="flex w-[100%] sm:w-[100%] flex-col items-center">
                <img
                  className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full"
                  alt=""
                  src="/images/PK-Kunhalikutty.webp"
                />
                <m.span
                  className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block"
                  {...{ ...fadeIn, transition: { delay: 0.4 } }}
                >
                  Shri. P K Kunhalikutty
                </m.span>
                <m.span
                  className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block"
                  {...{ ...fadeIn, transition: { delay: 0.4 } }}
                >
                  Hon. Minister for Industries, Govt. of Kerala
                </m.span>
              </div>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col xs={12} sm={12} lg={4}>
              <div className="flex w-[100%] sm:w-[100%] flex-col items-center">
                <img
                  className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full"
                  alt=""
                  src="/images/Minhaj Alam_IAS.webp"
                />
                <m.span
                  className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block"
                  {...{ ...fadeIn, transition: { delay: 0.4 } }}
                >
                  Shri. Minhaj Alam IAS
                </m.span>
                <m.span
                  className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block"
                  {...{ ...fadeIn, transition: { delay: 0.4 } }}
                >
                  Agriculture Production Commissioner,
                  <br />
                  Govt. of Kerala
                  <br />
                  Project Director
                </m.span>
              </div>
            </Col>

            <Col xs={12} sm={12} lg={4}>
              {/* <div className="flex flex-col w-[100%] sm:w-[100%] items-center">
                <img
                  className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full"
                  alt=""
                  src="/images/vishnuraj.webp"
                />
                <m.span
                  className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block"
                  {...{ ...fadeIn, transition: { delay: 0.4 } }}
                >
                  Shri. Vishnuraj P. IAS
                </m.span>
                <m.span
                  className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block"
                  {...{ ...fadeIn, transition: { delay: 0.4 } }}
                >
                  Director of Industries, Govt. of Kerala
                  <br />
                  Additional Project Director
                </m.span>
              </div> */}
            </Col>
            <Col xs={12} sm={12} lg={4}>
              <div className="flex w-[100%] sm:w-[100%] flex-col items-center">
                <img
                  className="w-[150px] h-[150px] sm:w-[150px] sm:h-[150px] rounded-full"
                  alt=""
                  src="/images/IMG-20260525-WA0162.webp"
                />
                <m.span
                  className=" font-bold text-center text-[16px] mt-[10px]  font-serif text-darkgray  block"
                  {...{ ...fadeIn, transition: { delay: 0.4 } }}
                >
                  Shri. K. Inbasekhar IAS
                </m.span>
                <m.span
                  className="mb-[5px] text-center text-[14px] mt-[1px]  font-serif text-gray  block"
                  {...{ ...fadeIn, transition: { delay: 0.4 } }}
                >
                  Managing Director of Kerala Water Authority,
                  <br />
                  Assistant Project Director
                </m.span>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </m.div>
  );
};

export default Leadership;
